export interface Access {
  Roles: string[]
  Policies: { [key: string]: boolean }
  IsSuper: boolean
  IsMFA: boolean
  MFARestricted: boolean
  AttributesFast: unknown
  FeaturesFast: Record<string, any>
  Name: string
  Protected: boolean
  SecurityPrincipal: string
  RequireMFA: boolean
  SecurityPrincipalName: string
  Description: null
  AttributeMode: string
  Attributes: any[]
  FeatureMode: string
  Features: any[]
  ShutterViews: null
  AccessList: AccessList[]
}

export interface AccessList {
  $type: string
  Mode: string
  Action: string
  Resources: string[]
  ScopeRule: string
}

function getAccess(): Access {
  const access = document.querySelector('#access')?.textContent
  return JSON.parse(access || '{}')
}

export function hasAccess(action: string, resource?: string): boolean {
  const access = getAccess()

  if (!Object.keys(access).length || access.IsSuper)
    return true

  if (!resource) {
    // feature test
    if (access.FeatureMode === 'GrantAll' || access.FeaturesFast[action])
      return true

    return false
  }

  // We have to test for undefined, since 'false' means granted but unscoped
  if (access.Policies[`${action}|${resource}`] !== undefined)
    return true

  return false
}
